module.exports = __webpack_public_path__ + "static/Adieu-Bold-4152afdd3691969ae5fef85f28a8176e.otf";